import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import StepIcon from '../../assets/StepIcon';
import LineIcon from '../../assets/LineIcon';

const useStyles = makeStyles(() => ({
  stepsDiv: {
    marginTop: '10px',
    width: '100%',
  },
  stepsContainer: {
    display: 'flex',
    padding: '12px',
    alignItems: 'flex-start',
    alignSelf: 'strech',
    gap: '16px',
    borderRadius: '8px',
    border: '1px solid var(--brand-200, #D9D6FE)',
    background: 'var(--brand-50, #F4F3FF)',
  },
  stepText: {
    fontFamily: 'Montserrat',
    color: '#667085',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '10px',
  },
  stepDesc: {
    fontFamily: 'Montserrat',
    color: '#10182B',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '13px',
  },
  stepDealershipsDesc: {
    fontFamily: 'Montserrat',
    color: '#10182B',
    fontStyle: 'normal',
    fontWeight: '600',
    fontSize: '15px',
    marginLeft: '8px',
  },
  stepInnerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
}));

const getTextAndCircleColor = (currentStep, step) => {
  const start = { circleColor: '#FEFEFE', textColor: '#10182B', borderColor: 'transparent' };
  const selected = { circleColor: '#622FEE', textColor: '#FEFEFE', borderColor: 'transparent' };
  const completed = { circleColor: '#FEFEFE', textColor: '#622FEE', borderColor: '#BEB3FF' };
  if (currentStep === step) return selected;
  if (currentStep > step) return completed;
  return start;
};

export default function Steps({ step, stepInfo }) {
  const classes = useStyles();

  return (
    <div className={classes.stepsDiv}>
      <div className={classes.stepsContainer}>
        <Grid container direction="row" justifyContent="space-between">
          {stepInfo?.map((info, index) => (
            <>
              <Grid item>
                <Grid className={classes.stepInnerContainer} container direction="row">
                  <Grid item>
                    <StepIcon step={`0${index + 1}`} color={getTextAndCircleColor(step, index + 1)} />
                  </Grid>
                  <Grid item>
                    <Grid container direction="column">
                      <Grid item className={classes.stepText}>
                        STEP 0{index + 1}
                      </Grid>
                      <Grid item className={classes.stepDesc}>
                        {info}
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {index + 1 < stepInfo?.length && (
                <Grid item>
                  <LineIcon />
                </Grid>
              )}
            </>
          ))}
        </Grid>
      </div>
    </div>
  );
}
